import type { CheckboxProps } from '@mui/material';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from '@mui/material';
import type { FormikProps } from 'formik';
import type { ReactNode } from 'react';

type Props<ID, T> = CheckboxProps & {
  id: ID;
  error?: boolean;
  formik: FormikProps<T>;
  helperText?: ReactNode;
  label: ReactNode;
};

export function FormikCheckbox<
  ID extends string,
  T extends { [key in ID]?: boolean },
>(props: Props<ID, T>): JSX.Element {
  const { formik, label } = props;
  return (
    <FormControl
      component="fieldset"
      error={Boolean(formik.errors[props.id]) || props.error}
      variant="standard"
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={formik.values[props.id]}
            disabled={formik.isSubmitting || props.disabled}
            id={props.id}
            name={props.name ?? props.id}
            onBlur={formik.handleBlur}
            onChange={(_, value) => formik.setFieldValue(props.id, value)}
          />
        }
        disabled={formik.isSubmitting || props.disabled}
        label={label}
      />
      <FormHelperText>
        {(formik.errors[props.id] as string) || props.error || props.helperText}
      </FormHelperText>
    </FormControl>
  );
}
